import {Notyf} from 'notyf';
import 'notyf/notyf.min.css';
import {ngIconMarkup} from './ng-icons';

// Kvitteringerne står som kort på surf-fladen (skærm 09), ikke som
// farvede piller. Farverne skrives som var()-udtryk, fordi notyf sætter
// dem inline — så følger de også temaskiftet.
const surface = 'var(--c-surf, #fff)';

const icon = (name, tone) => ngIconMarkup(name, `ng-receipt-icon ng-receipt-icon--${tone}`, 18);

const config = {
    duration: 5000,
    position: {
        x: 'center',
        y: 'bottom',
    },
    types: [
        {
            type: 'info',
            background: surface,
            duration: false,
            icon: icon('info', 'info'),
        },
        {
            type: 'loader',
            className: 'notyf__toast--loader',
            background: 'transparent',
            duration: false,
            icon: false,
            ripple: false,
        },
        {
            type: 'warning',
            background: surface,
            icon: icon('alert', 'warn'),
        },
        {
            type: 'error',
            background: surface,
            duration: 4000,
            dismissible: true,
            icon: icon('alert', 'bad'),
        },
        {
            type: 'success',
            background: surface,
            duration: 3000,
            icon: icon('check', 'ok'),
        },
    ],
};


export class Notifications {
    constructor() {
        this.notyf = new Notyf(config);
    }

    removeAll() {
        this.notyf.dismissAll();
    }

    remove(notification) {
        this.notyf.dismiss(notification);
    }

    info(message) {
        return this.notyf.open({
            type: 'info',
            message: message,
        });
    }

    loading(loaderMarkup, announcement = '') {
        return this.notyf.open({
            type: 'loader',
            icon: loaderMarkup,
            message: announcement,
        });
    }

    success(message) {
        return this.notyf.success(message);
    }

    error(message) {
        return this.notyf.error(message);
    }
}
